<div class="container-fluid mt-5">
  <!-- <div class="user">
    <i class="fas fa-user-circle fa-2x"></i>
    <span class="user-name ml-2">{{user.idUser}}</span>
  </div> -->
  <div class="jumbotron text-center">
    <h1>
      <img class="logo" src="assets/images/img-01.png" alt="angular logo" />
      <span *ngIf="user" translate class="pl-4">Hola {{ user.email }}</span>
    </h1>
    <app-loader [isLoading]="isLoading"></app-loader>
    <!-- <q [hidden]="isLoading">{{ quote }}</q> -->
  </div>
</div>
